




const cursorTag = document.querySelector("div.cursorsZ")
const balls = cursorTag.querySelectorAll("div")

let aimX = 0
let aimY = 0

let hue = Math.floor(Math.random() * 359)

balls.forEach((ball, index) => {
  let currentX = 0
  let currentY = 0

  
  let speed = 0.239 - index * 0.012345

  const animate = function() {
    currentX += (aimX - currentX) * speed
    currentY += (aimY - currentY) * speed
    ball.style.left = currentX + "px"
    ball.style.top = currentY + "px"
    for(let i = 0; i < 10; i++)
    {
      let hue = Math.floor(Math.random() * 359)
      ball.style.filter = "hue-rotate(" + hue + "deg)"
    }
    
    requestAnimationFrame(animate)
  }

  animate()

})



document.addEventListener("mousemove", function (event){
  aimX = event.pageX
  aimY = event.pageY
})


